import type { InjectableDependencies } from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as dms from '../../../dms'
import type * as me from '../../../me'
import * as ec from '../ec'
import type { Feature } from '../feature'

/**
 * Bootstrap the {@link ec.Collection}
 */
export const onBootstrap = store.effects.create(
  (
    feature: Feature,
    meFeature: me.Feature,
    schemaFeature: dms.schema.Feature,
    ecDependencies: InjectableDependencies,
  ) =>
    feature.actions.bootstrap.observe().pipe(
      rxjs.map(({ data: { rendering, ref, actionHandlers } }) => {
        /**
         * NOTE: Creating a new instance automatically registers it in
         * {@link ec.Collection.instances} for later retrieval.
         */
        new ec.Collection(
          {
            actionHandlers,
            meFeature,
            ref,
            rendering,
            schemaFeature,
          },
          ecDependencies,
        )

        // NOTE: this effect operates purely as a side-effect and doesn't
        // require a return value
        return store.effects.SKIP
      }),
    ),
)
